import React from 'react';
import styled, { keyframes } from 'styled-components';

interface ICustomSpinner {
  color?: string;
  bgColor?: string;
  width?: number;
  height?: number;
}

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div<ICustomSpinner>`
  font-size: 10px;
  text-indent: -9999em;
  width: ${({ width }) => width + 'px'};
  height: ${({ height }) => height + 'px'};
  border-radius: 50%;
  background: ${({ color }) => color};
  background: linear-gradient(to right, ${({ color }) => color} 10%, rgba(255, 255, 255, 0) 42%);
  position: relative;
  animation: ${rotateAnimation} 1.4s infinite linear;
  transform: translateZ(0);

  &:before {
    width: 50%;
    height: 50%;
    background: ${({ color }) => color};
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }

  &:after {
    background: ${({ bgColor }) => bgColor};
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`;

export const CustomSpinner: React.FC<ICustomSpinner> = ({
  color = '#000',
  bgColor = '#fff',
  width = 25,
  height = 25
}) => <Spinner color={color} bgColor={bgColor} width={width} height={height} />;
